var map = {
	"./AbouUs - Copy.png": 2448,
	"./AbouUs.png": 3178,
	"./Blogs - Copy.png": 8430,
	"./Blogs.png": 2452,
	"./Dummy.mp4": 4316,
	"./FlexabileClasses-ar.png": 7847,
	"./FlexabileClasses.png": 3271,
	"./Hero.svg": 9401,
	"./Hero.webp": 679,
	"./HeroBg.png": 4778,
	"./Intersect.png": 2644,
	"./Line.png": 5765,
	"./Our-team-bg.png": 6963,
	"./PassedQuiz.svg": 2618,
	"./Populer-bg.png": 4918,
	"./Search.png": 3039,
	"./TRAINER.png": 5340,
	"./about-bg.png": 8962,
	"./aboutCompany.png": 3303,
	"./arrow-Bg.png": 6886,
	"./arrow-icon.png": 4828,
	"./attemp.svg": 2400,
	"./attempt.svg": 5900,
	"./authBg - Copy.png": 4218,
	"./authBg.png": 3112,
	"./award.svg": 5388,
	"./award2.svg": 3126,
	"./blog-bg.png": 2119,
	"./book.png": 7548,
	"./book.svg": 1718,
	"./certificate-icon.png": 7274,
	"./checkd.png": 1215,
	"./commuincate.png": 7574,
	"./course-details.png": 4577,
	"./course.png": 4324,
	"./email.png": 4931,
	"./expert-icon.png": 7201,
	"./facebook.svg": 9321,
	"./fly.png": 4280,
	"./footer.png": 7338,
	"./google.svg": 8336,
	"./heroArrow - Copy.png": 9466,
	"./heroArrow.png": 5960,
	"./img1.png": 3725,
	"./img2.png": 9750,
	"./instapay.png": 4354,
	"./instructor-image.png": 3430,
	"./joba-close-menu.svg": 4244,
	"./joba-menu.svg": 8797,
	"./juba.svg": 9741,
	"./learn.png": 9705,
	"./left-page-arrow.svg": 6170,
	"./login.png": 3388,
	"./logo-white.png": 2106,
	"./marks.svg": 585,
	"./minimum.svg": 4923,
	"./no-data.png": 6329,
	"./note-2.svg": 7740,
	"./orangeArrow.png": 4510,
	"./our-courses-arrow.png": 5112,
	"./our-team.png": 2467,
	"./ourcourses-img.png": 9529,
	"./passed.svg": 1057,
	"./point.png": 7849,
	"./populerCourse-icon.png": 4717,
	"./pro.png": 5130,
	"./quality.png": 7560,
	"./quiz-image.svg": 9118,
	"./quiz.svg": 2766,
	"./register-logo.svg": 4238,
	"./register.png": 1056,
	"./right-page-arrow.svg": 1095,
	"./send-icon.png": 839,
	"./student-ex.png": 4222,
	"./studentsSayBg.png": 5767,
	"./support.png": 1254,
	"./teach.png": 4236,
	"./test.png": 4599,
	"./time-icon.png": 636,
	"./underline.png": 5271,
	"./user.png": 226,
	"./user.svg": 3084,
	"./visa-pay.png": 1273,
	"./wallet.png": 4068,
	"./whatOffer.png": 999,
	"./white-logo.svg": 4688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3907;